import React, { useState, useEffect } from "react";
import axios from "axios";

import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { C, S } from "./styles";
import ManageUser from "../User";

function UsersPage() {
  const [purchased, setPurchased] = useState(null);
  const [used, setUsed] = useState(null);

  useEffect(() => {
    axios
      .get(API + "paymentsub/subscription/", { headers: authHeader() })
      .then((res) => {
        if (res.data && res.data.success === 1 && res.data.data) {
          setPurchased(res.data.data.no_of_users ?? 0);
        }
      })
      .catch(() => {});

    axios
      .get(API + "company/users/", { headers: authHeader() })
      .then((res) => {
        setUsed(Array.isArray(res.data) ? res.data.length : 0);
      })
      .catch(() => {});
  }, []);

  const hasData = purchased !== null && used !== null;
  const remaining = hasData ? Math.max(purchased - used, 0) : null;
  const atLimit = hasData && purchased > 0 && used >= purchased;

  return (
    <>
      {hasData && (
        <div style={S.licenseCard}>
          <i className="fa-solid fa-id-badge" style={{ color: C.primary, fontSize: 13 }} />

          <div style={S.licenseStat}>
            <span style={S.licenseStatNum}>{purchased}</span>
            <span style={S.licenseStatLabel}>Purchased</span>
          </div>

          <div style={S.licenseDivider} />

          <div style={S.licenseStat}>
            <span style={S.licenseStatNum}>{used}</span>
            <span style={S.licenseStatLabel}>Used</span>
          </div>

          <div style={S.licenseDivider} />

          <div style={S.licenseStat}>
            <span style={{ ...S.licenseStatNum, color: atLimit ? C.warning : C.success }}>
              {remaining}
            </span>
            <span style={S.licenseStatLabel}>Remaining</span>
          </div>
        </div>
      )}

      <ManageUser />
    </>
  );
}

export default UsersPage;
